import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import layer1 from '../../../assets/img/LoginImages/1 - layer1.png';
import sky from '../../../assets/img/LoginImages/7 - sky background.png';
import clouds from '../../../assets/img/LoginImages/6 - clouds.png';
import birds from '../../../assets/img/LoginImages/5 - birds.png';
import layer3 from '../../../assets/img/LoginImages/4 - layer3.png';
import layer2 from '../../../assets/img/LoginImages/3 - layer2.png';
import deer2 from '../../../assets/img/LoginImages/2 - deer2.png';
import text from '../../../assets/img/LoginImages/text.png';
import { Updatetime, Updatetask, LoginMessgae, UpdateLoginTime } from '../../../Slices/timerslice.jsx';
import { setId } from '../../../Slices/employeeslice.js';
import { useDispatch } from 'react-redux';
import '../../../assets/css/LoginNew.css';
import { message, Spin } from 'antd';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import CryptoJS from 'crypto-js';
import Swal from "sweetalert2";
import { fetchNestedData, fetchData } from '../../../Slices/dataBucket.js';
import { useSelector } from 'react-redux';
import { InputField, AntdButton } from '../../../blueplanitUtils/InputField.jsx';
import NotificationListener from '../Sales1/emailsocket.js';
import { fetchClients } from "../../../Slices/clientSlice";
import { attendenceLoginThunk, authLoginThunk, authResetPasswordThunk, createLoginWorkHistoryAsync, createWorkHistoryThunk, fetchAllRecordsAsync, fetchAllUsersThunk, fetchDynamicRoutes, fetchUserDetails, resetTokenThunk } from '../../../Slices/Thunk/LoginThunk.js';
import { getProgress } from '../../../Slices/attendenceSlice.js';
import { getAllClientsData, setPunchInStatus } from '../../../Slices/loginUserSlice.jsx';
import { fetchEmployeeAccess } from '../../../Slices/employeeslice.js';
 
const LoginN = () => {
    const dispatch = useDispatch();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [tokenKey, setTokenKey] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const lastAttendance = useSelector((state) => state.Attendence.lastRecord);
    const [loading, setLoading] = useState(false);
    const [loginLoading, setLoginLoading] = useState(false)
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const history = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [activeForm, setActiveForm] = useState("login");
    const { LoginMessgae } = useSelector((state) => state.timer);
 
    useEffect(() => {
        if (isLoggedIn) {
            dispatch(fetchData());
        }
    }, [dispatch, isLoggedIn]);
 
    useEffect(() => {
        dispatch(fetchDynamicRoutes(isLoggedIn))
    }, [dispatch, isLoggedIn]);
 
 
    const handleResetToken = async (event) => {
        event.preventDefault();
        if (!email) {
            message.warning("Please enter your Email!");
            return;
        }
        setLoading(true);
        try {
            dispatch(resetTokenThunk(email))
        } catch (error) {
            message.error("Failed to reset token. Please try again.");
        }
        setLoading(false);
    };
    
 
    const parseJwt = (token) => {
        try {
            return token ? JSON.parse(atob(token.split(".")[1])) : null;
        } catch (e) {
            return null;
        }
    };
    const CreateLoginWorkHistory = async (userid) => {
        try {
 
            const loginResultAction = await dispatch(createLoginWorkHistoryAsync(
                { userId: parseJwt(userid)?.id?.toString(), title: "", description: "", companyname: "BlueplanIt", department: "", task: 'login', date: "", startTime: new Date().toISOString(), endTime: "" }
            ))
 
            const valuesObject = {
                userId: parseJwt(userid)?.id,
                emailId: '',
                requestId: '',
                clientName: 'Blueplanit',
                processType: '',
                taskType: 'Available',
                email: '',
                subject: '',
                body: '',
                startTime: Date.now().toString(),
                endTime: '',
            }
            const resultAction = await dispatch(createWorkHistoryThunk(valuesObject));
 
            if (createWorkHistoryThunk.fulfilled.match(resultAction)) {
                const Workresponse = resultAction.payload;
 
                dispatch(Updatetime(Number(Workresponse.startTime)));
                dispatch(Updatetask(Workresponse.taskType));
                dispatch(UpdateLoginTime(Number(Workresponse.startTime)));
                localStorage.setItem('time', Workresponse.startTime);
                localStorage.setItem('task', Workresponse.taskType);
                localStorage.setItem('LoginTime', Workresponse.startTime);
            } else {
                console.error("Failed to create work history:", resultAction.payload);
            }
 
        } catch (err) {
            console.error('Error:', err);
        }
    };
 
    const PunchHander = (userId, punchInStatusFromLogin) => {
        if (!lastAttendance || !punchInStatusFromLogin) {
            Swal.fire({
                title: "Please Punch In",
                text: "Punch in before starting your work",
                html: `${LoginMessgae ? `<p style="color:red;">${LoginMessgae}</p>` : ''}`,
                icon: "warning",
                confirmButtonText: "Punch In",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCloseButton: true,
            }).then(async (result) => {
                if (!result.isConfirmed) return;
                try {
                    const punchInTime = Date.now().toString();
                    await dispatch(attendenceLoginThunk({
                        empId: userId,
                        punchIn: punchInTime,
                        status: true,
                        elapsedTime: 0
                    }));
                    dispatch(setPunchInStatus(true));
                } catch (error) {
                    console.error("Error during punch-in:", error);
                    Swal.fire("Error", "Failed to punch in. Please try again.", "error");
                }
            });
        }
    }
 
    const handleLoginSubmit = async (event) => {
        event.preventDefault();
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email || !emailPattern.test(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        if (password.length < 6) {
            setError('Password must be at least 6 characters long.');
            return;
        }

 
        try {
            setLoginLoading(true)
            const resultAction = await dispatch(
                authLoginThunk({
                    email,
                    password,
                    platform: "WEB" // ✅ ADD THIS LINE
                })
            );
 
            if (authLoginThunk.fulfilled.match(resultAction)) {
                const { token, response, message } = resultAction.payload;
                localStorage.setItem('token', token);
 
                const userId = parseJwt(token)?.id;
                dispatch(fetchUserDetails(userId));
                dispatch(fetchEmployeeAccess({userId}));
                dispatch(fetchClients());
                await CreateLoginWorkHistory(token);
                dispatch(setId(true));
 
                dispatch(fetchNestedData(userId));
                dispatch(fetchAllUsersThunk(userId))
                dispatch(getProgress({ id: userId }));
                dispatch(fetchAllRecordsAsync({ userId }));
                setError('');
                setSuccessMessage(message);
                // Check if MyDashboard is accessible in the user's menu
                const hasMyDashboard = response?.menu?.some((mainRoute) =>
                    mainRoute.status && mainRoute?.Subfields?.some((sub) => sub.status && (sub.name === "/MyDashboard" || sub.name === "MyDashboard"))
                );

                const fallbackRoute = response?.menu?.find((mainRoute) =>
                    mainRoute.status && mainRoute?.Subfields?.find((subRoute) => subRoute.status)
                )?.Subfields?.find((subRoute) => subRoute.status)?.name;

                setIsLoggedIn(true);
                // Webtop cutover: the windows shell is now the only view; land there
                // after login. (Legacy targetRoute kept below for rollback reference.)
                // const targetRoute = hasMyDashboard ? "/MyDashboard" : (fallbackRoute || "/profile");
                void hasMyDashboard; void fallbackRoute; // (retained for rollback)
                setTimeout(() => {
                    history("/webtop");
                    PunchHander(userId, resultAction.payload.response?.punchInStatus);
                }, 3000);

            } else {
                setError(resultAction.payload || 'Login error. Please check your credentials.');
                setSuccessMessage('');
            }
        } catch (error) {
            console.error("Login failed:", error);
            setError("Login failed, please try again.");
        }
        finally {
            setLoginLoading(false)
        }
 
    };
 
   const handleResetSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccessMessage('');

    if (newPassword.length < 6) {
        setError('New password must be at least 6 characters long.');
        return;
    }

    if (newPassword !== confirmPassword) {
        setError('Passwords do not match!');
        return;
    }

    setLoading(true);

     

    try {
        const resultAction = await dispatch(
            authResetPasswordThunk({
                email,
                token: tokenKey,
                password: newPassword,
                isPasswordGenerated: true
            })
        );

        setLoading(false);

        // ✅ SUCCESS PATH
         if (authResetPasswordThunk.fulfilled.match(resultAction)) {
                const { status } = resultAction.payload;
 
                if (status === 200) {
                    setSuccessMessage('Password reset successfully!');
                    setError('');
 
                    setTimeout(() => {
                        handleFormSwitch('login'); // Switch form
                        history('/');              // Redirect to login
                    }, 1000);
 
                } else {
                    setError(resultAction.payload.message || 'Reset error');
                    setSuccessMessage('');
                }
            } else {
                setError(resultAction.payload || 'Reset failed, please try again.');
                setSuccessMessage('');
            }
 
        // ❌ ERROR PATH (backend returned error object)
        
    } catch (error) {
        console.error("Reset password failed:", error);
        setError("Reset failed, please try again.");
    } finally {
        setLoading(false);
    }
};

 
 
 
 
    useEffect(() => {
 
        localStorage.removeItem("LoginTime");
 
        localStorage.removeItem("time");
        let bg = document.getElementById('bg');
        let deer = document.getElementById('deer');
        let clouds = document.getElementById('clouds');
        let birds = document.getElementById('birds');
        let layer3 = document.getElementById('layer3');
        let layer2 = document.getElementById('layer2');
        let text = document.getElementById('text');
 
        const scrollHandler = () => {
            var value = window.scrollY;
            if (bg) bg.style.top = value * 0.5 + 'px';
            if (deer) deer.style.left = value * 0.1 + 'px';
            if (clouds) clouds.style.left = value * 0.2 + 'px';
            if (birds) birds.style.left = -value * 0.4 + 'px';
            if (layer3) layer3.style.top = value * 0.3 + 'px';
            if (layer2) layer2.style.top = value * 0.1 + 'px';
            if (text) text.style.top = value * 0.3 + 'px';
        };
        window.addEventListener('scroll', scrollHandler);
        return () => window.removeEventListener('scroll', scrollHandler);
    }, []);
 
    const handleFormSwitch = (formName) => {
        setActiveForm(formName);
        setError('');
        setSuccessMessage('');
 
        setEmail('');
        setPassword('');
        setTokenKey('');
        setNewPassword('');
        setConfirmPassword('');
        setShowPassword(false);
        setShowNewPassword(false);
        setShowConfirmPassword(false);
    };
    console.log('development mode--1')
    return (
        <>
            <NotificationListener />
            <section>
                <img src={sky} id="bg" alt="Background" />
                <img src={clouds} id="clouds" alt="Clouds" />
                <img src={birds} id="birds" alt="Birds" />
                <img src={layer3} id="layer3" alt="Layer 3" />
                <img src={layer2} id="layer2" alt="Layer 2" />
                <img src={deer2} id="deer" alt="Deer" />
                <img src={text} id="text" alt="Text" />
                <img src={layer1} id="layer1" alt="Layer 1" />
            </section>
            <div className="mouse-design">
                <div className="scroll-downs">
                    <div className="mousey">
                        <div className="scroller"></div>
                    </div>
                </div>
            </div>
            <section>
                <div className="form-design">
                    <div className="wrapper">
                        {/* Login Form */}
                        {activeForm === 'login' && (
                            <div className="form-box login">
                                <h2>Login</h2>
                                <form onSubmit={handleLoginSubmit}>
                                    {error && <div className="error">{error}</div>}
                                    {successMessage && <div className="success">{successMessage}</div>}
 
                                    <div className="input-box">
                                        {email === '' && <label> Email</label>}
                                        <InputField
                                            type="text"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                    <div className="input-box">
                                        {password === '' && <label> Password</label>}
                                        <InputField
                                            type={showPassword ? 'text' : 'password'}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <span onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                                            {showPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                        </span>
                                    </div>
                                    <div className="remember-reset">
                                        <label>
                                            <input type="checkbox" />
                                            Remember me
                                        </label>
                                        <Link className="resetToken-link" onClick={() => handleFormSwitch('resetToken')}>
                                            Reset Token
                                        </Link>
                                        <Link className="reset-link" onClick={() => handleFormSwitch('reset')}>
                                            Reset Password
                                        </Link>
                                    </div>
                                    <AntdButton
                                        label="Login"
                                        htmlType="submit"
                                        style={{ color: 'white' }}
                                        className="btn-btn"
                                    />
                                </form>
                            </div>
                        )}
 
                        {loginLoading && (
                            <div className="loader-container">
                                <Spin size="large" />
                            </div>
                        )}
 
 
                        {/* Reset Token */}
                        {activeForm === 'resetToken' && (
                            <div className="form-box resetToken">
                                <h2>Reset Token</h2>
                                <form onSubmit={handleResetToken}>
 
                                    {error && <div className="error">{error}</div>}
                                    {successMessage && <div className="success">{successMessage}</div>}
 
                                    <div className="input-box">
                                        <InputField
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        //required
                                        />
                                        {email === '' && <label> Email</label>}
                                    </div>
                                    <div className="remember-reset">
                                        {/* <label>
                                            <input type="checkbox" />I agree to terms & conditions
                                        </label> */}
                                        <Link className="login-link" to="/" onClick={() => handleFormSwitch('login')}>
                                            Login
                                        </Link>
                                        <Link className="reset-link" onClick={() => handleFormSwitch('reset')}>
                                            Reset Password
                                        </Link>
                                    </div>
                                    <AntdButton
                                        type="primary"
                                        htmlType="submit"
                                        className="btn-btn"
                                        disabled={loading}
                                        label={loading ? 'Resetting...' : 'Reset'}
                                    />
                                </form>
                            </div>
                        )}
 
 
                        {/* Reset Password Form */}
                        {activeForm === 'reset' && (
                            <div className="form-box reset">
                                <h2>Reset Password</h2>
                                <form onSubmit={handleResetSubmit}>
 
                                    {error && <div className="error">{error}</div>}
                                    {successMessage && <div className="success">{successMessage}</div>}
 
                                    <div className="input-box">
                                        <InputField
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        //required
                                        />
                                        {email === '' && <label> Email</label>}
                                    </div>
                                    <div className="input-box">
                                        <InputField
                                            className="token"
                                            type="text"
                                            value={tokenKey}
                                            onChange={(e) => setTokenKey(e.target.value)}
                                        //required
                                        />
                                        {tokenKey === '' && <label> Token Key</label>}
                                    </div>
                                    <div className="input-box">
                                        <InputField
                                            type={showNewPassword ? 'text' : 'password'}
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                        //required
                                        />
                                        {newPassword === '' && <label> New Password</label>}
                                        <span onClick={() => setShowNewPassword(!showNewPassword)} style={{ cursor: 'pointer', }}>
                                            {showNewPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                        </span>
                                    </div>
                                    <div className="input-box">
                                        <InputField
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        //required
                                        />
                                        {confirmPassword === '' && <label> Confirm Password</label>}
                                        <span onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{ cursor: 'pointer' }}>
                                            {showConfirmPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                        </span>
                                    </div>
                                    <div className="remember-reset">
                                        <label>
                                            <input type="checkbox" />I agree to terms & conditions
                                        </label>
                                        <Link className="login-link" onClick={() => handleFormSwitch('resetToken')}>
                                            Reset Token
                                        </Link>
                                        <Link className="login-link" onClick={() => handleFormSwitch('login')}>
                                            Login
                                        </Link>
                                    </div>
                                    <AntdButton
                                        type="primary"
                                        htmlType="submit"
                                        className="btn-btn"
                                        disabled={loading}
                                        label={loading ? 'Resetting...' : 'Reset'}
                                    />
                                </form>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};
 
export default LoginN;
 
 